import { initSizes, initExtraSizes } from "./../../data/patternSize";

export default {
  item: [],
  item_list: [],
  inputList: {
    user_id: "",
    work_name: "",
    work_id: "",
    total_quantity: "",
    due_date: null,
    cus_id: "",
    cus_name: "",
    cus_company: "",
    cus_address: "",
    cus_tel_1: "",
    cus_email: "",
    fabric_name: "",
    fabric_no: "",
    fabric_color: "",
    fabric_color_no: "",
    fabric_factory: "",
    crewneck_selected: 0,
    crewneck_color: "",
    fabric_custom_color: [],
    pattern_name: "",
    pattern_gender: "unisex",
    pattern_type: 1,
    pattern_sizes: initSizes,
    screen_point: "",
    screen_flex: "",
    screen_dft: "",
    screen_label: "",
    screen_embroider: "",
    screen_detail: "",
    exam_date: null,
    example_quantity: [],
    worksheet_note: "",
    type_shirt: "t-shirt",
    size_tag: "",
    packaging: "",
    shirt_detail: "",
    collar: 1,
    collar_type: 1,
    other_collar_type: "",
    collar_type_detail: "",
    placket: 1,
    other_placket: "",
    outer_placket: false,
    outer_placket_detail: "",
    inner_placket: false,
    inner_placket_detail: "",
    button: 1,
    other_button: "",
    button_color: "",
    sleeve: 1,
    sleeve_detail: "",
    pocket: 1,
    pocket_detail: "",
    bottom_hem: false,
    bottom_hem_detail: "",
    back_seam: false,
    back_seam_detail: "",
    side_vents: false,
    side_vents_detail: "",
    polo_embroider: [{ embroider_position: 1, embroider_size: "" }],
    creator_name: "",
    manager_name: "",
    production_name: "",
    nws_created_date: null,
    nws_created_by: "",
    nws_updated_date: null,
    nws_updated_by: "",
    images: "",
    is_duplicate: false,
  },
  extraSizes: initExtraSizes,
  crewneck_selected: false,
  customerList: [],
  is_edit_worksheet: false,
  is_create_worksheet: false,
  edit_item: {},
  sumQuantity: { total: "", men: "", women: "" },
  sumQuantityMen: "",
  sumQuantityWomen: "",
  shirtDetailLen: 3,
  screenDetailLen: 3,
  creatorList: [],
  managerList: [],
  productionList: [],
  errorMsg: "",
};